import * as React from 'react'
import { ComponentType, lazy, Suspense } from 'react'
import { Loading } from '@components/loading'

export function lazyPage<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  const LazyComponent = lazy(factory)
  return (props: any) => (
    <Suspense fallback={<Loading />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
